import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      "app_name": "Indian Festival Calendar",
      "select_language": "Select Your Language",
      "welcome": "Welcome",
      "festivals": "Festivals",
      "calendar": "Calendar",
      "login": "Login",
      "logout": "Logout",
      "email": "Email",
      "password": "Password",
      "admin_dashboard": "Admin Dashboard",
      "super_admin": "Super Admin",
      "manage_festivals": "Manage Festivals",
      "manage_languages": "Manage Languages",
      "manage_users": "Manage Users",
      "reports": "Reports",
      "add_festival": "Add Festival",
      "edit_festival": "Edit Festival",
      "delete_festival": "Delete Festival",
      "festival_name": "Festival Name",
      "festival_date": "Date",
      "festival_description": "Description",
      "images": "Images",
      "videos": "Videos",
      "save": "Save",
      "cancel": "Cancel",
      "delete": "Delete",
      "view_details": "View Details",
      "close": "Close",
      "loading": "Loading...",
      "no_festivals": "No festivals found",
      "theme": "Theme",
      "light": "Light",
      "dark": "Dark",
      "light_mode": "Light Mode",
      "dark_mode": "Dark Mode",
      "wishes_gallery": "Wishes Gallery",
      "wishes_gallery_subtitle": "Choose a template and add your personalized message",
      "search_placeholder": "Search by occasion or tags...",
      "filters": "Filters",
      "all": "All",
      "festival": "Festival",
      "birthday": "Birthday",
      "anniversary": "Anniversary",
      "holiday": "Holiday",
      "other": "Other",
      "no_media_found": "No media found. Try adjusting your filters.",
      "menu": "Menu",
      "admin_panel": "Admin Panel",
      "wishes": "Wishes",
      "language": "Language",
      "month_january": "JANUARY",
      "month_february": "FEBRUARY",
      "month_march": "MARCH",
      "month_april": "APRIL",
      "month_may": "MAY",
      "month_june": "JUNE",
      "month_july": "JULY",
      "month_august": "AUGUST",
      "month_september": "SEPTEMBER",
      "month_october": "OCTOBER",
      "month_november": "NOVEMBER",
      "month_december": "DECEMBER",
      "day_sun": "SUN",
      "day_mon": "MON",
      "day_tue": "TUE",
      "day_wed": "WED",
      "day_thu": "THU",
      "day_fri": "FRI",
      "day_sat": "SAT",
      "click_smiley_text": "CLICK ON THE",
      "for_greetings_text": "FOR PERSONALIZED GREETINGS",
      "no_festival_month": "No Festival This Month",
      "no_festival_scheduled": "There are no festivals scheduled for this month.",
      "install_app": "Install App on iPhone",
      "ios_install_instruction_1": "Follow these steps to add this app to your iPhone Home Screen:",
      "ios_install_step_1": "Tap the Share button ",
      "ios_install_step_1_suffix": " at the bottom of Safari browser",
      "ios_install_step_2": "Scroll down and tap on \"Add to Home Screen\"",
      "ios_install_step_3": "Tap \"Add\" button in the top right corner to confirm",
      "ios_install_step_4": "The app icon will appear on your Home Screen and you can open it like any other app!"
    }
  },
  hi: {
    translation: {
      "app_name": "भारतीय त्योहार कैलेंडर",
      "select_language": "अपनी भाषा चुनें",
      "welcome": "स्वागत है",
      "festivals": "त्योहार",
      "calendar": "कैलेंडर",
      "login": "लॉग इन करें",
      "logout": "लॉग आउट",
      "email": "ईमेल",
      "password": "पासवर्ड",
      "admin_dashboard": "प्रशासक डैशबोर्ड",
      "super_admin": "सुपर एडमिन",
      "manage_festivals": "त्योहार प्रबंधित करें",
      "manage_languages": "भाषाएँ प्रबंधित करें",
      "manage_users": "उपयोगकर्ता प्रबंधित करें",
      "reports": "रिपोर्ट",
      "add_festival": "त्योहार जोड़ें",
      "edit_festival": "त्योहार संपादित करें",
      "delete_festival": "त्योहार हटाएं",
      "festival_name": "त्योहार का नाम",
      "festival_date": "तारीख",
      "festival_description": "विवरण",
      "images": "छवियाँ",
      "videos": "वीडियो",
      "save": "सहेजें",
      "cancel": "रद्द करें",
      "delete": "हटाएं",
      "view_details": "विवरण देखें",
      "close": "बंद करें",
      "loading": "लोड हो रहा है...",
      "no_festivals": "कोई त्योहार नहीं मिला",
      "theme": "थीम",
      "light": "हल्का",
      "dark": "अंधेरा",
      "light_mode": "लाइट मोड",
      "dark_mode": "डार्क मोड",
      "wishes_gallery": "शुभकामना गैलरी",
      "wishes_gallery_subtitle": "एक टेम्पलेट चुनें और अपना व्यक्तिगत संदेश जोड़ें",
      "search_placeholder": "अवसर या टैग द्वारा खोजें...",
      "filters": "फ़िल्टर",
      "all": "सभी",
      "festival": "त्योहार",
      "birthday": "जन्मदिन",
      "anniversary": "वर्षगांठ",
      "holiday": "छुट्टी",
      "other": "अन्य",
      "no_media_found": "कोई मीडिया नहीं मिला। अपने फ़िल्टर समायोजित करने का प्रयास करें।",
      "menu": "मेनू",
      "admin_panel": "एडमिन पैनल",
      "wishes": "शुभकामनाएं",
      "language": "भाषा",
      "month_january": "जनवरी",
      "month_february": "फ़रवरी",
      "month_march": "मार्च",
      "month_april": "अप्रैल",
      "month_may": "मई",
      "month_june": "जून",
      "month_july": "जुलाई",
      "month_august": "अगस्त",
      "month_september": "सितंबर",
      "month_october": "अक्टूबर",
      "month_november": "नवंबर",
      "month_december": "दिसंबर",
      "day_sun": "रवि",
      "day_mon": "सोम",
      "day_tue": "मंगल",
      "day_wed": "बुध",
      "day_thu": "गुरु",
      "day_fri": "शुक्र",
      "day_sat": "शनि",
      "click_smiley_text": "क्लिक करें",
      "for_greetings_text": "व्यक्तिगत शुभकामनाओं के लिए",
      "no_festival_month": "इस महीने कोई त्योहार नहीं",
      "no_festival_scheduled": "इस महीने के लिए कोई त्योहार निर्धारित नहीं है।",
      "install_app": "iPhone पर ऐप इंस्टॉल करें",
      "ios_install_instruction_1": "इस ऐप को अपने iPhone होम स्क्रीन पर जोड़ने के लिए इन चरणों का पालन करें:",
      "ios_install_step_1": "शेयर बटन पर टैप करें ",
      "ios_install_step_1_suffix": " Safari ब्राउज़र के निचले भाग में",
      "ios_install_step_2": "नीचे स्क्रॉल करें और \"होम स्क्रीन पर जोड़ें\" पर टैप करें",
      "ios_install_step_3": "पुष्टि करने के लिए ऊपर दाईं ओर \"जोड़ें\" बटन पर टैप करें",
      "ios_install_step_4": "ऐप आइकन आपकी होम स्क्रीन पर दिखाई देगा और आप इसे किसी अन्य ऐप की तरह खोल सकते हैं!"
    }
  },
  ta: {
    translation: {
      "app_name": "இந்திய திருவிழா நாட்காட்டி",
      "select_language": "உங்கள் மொழியைத் தேர்ந்தெடுக்கவும்",
      "welcome": "வரவேற்கிறோம்",
      "festivals": "திருவிழாக்கள்",
      "calendar": "நாட்காட்டி",
      "login": "உள்நுழைக",
      "logout": "வெளியேறு",
      "email": "மின்னஞ்சல்",
      "password": "கடவுச்சொல்",
      "loading": "ஏற்றுகிறது...",
      "no_festivals": "திருவிழாக்கள் இல்லை",
      "theme": "தீம்",
      "light": "வெளிச்சம்",
      "dark": "இருள்",
      "light_mode": "லைட் மோட்",
      "dark_mode": "டார்க் மோட்",
      "wishes_gallery": "வாழ்த்து தொகுப்பு",
      "wishes_gallery_subtitle": "ஒரு டெம்ப்ளேட்டைத் தேர்வு செய்து உங்கள் தனிப்பயனாக்கப்பட்ட செய்தியைச் சேர்க்கவும்",
      "search_placeholder": "சந்தர்ப்பம் அல்லது குறிச்சொற்கள் மூலம் தேடுங்கள்...",
      "filters": "வடிகட்டிகள்",
      "all": "அனைத்தும்",
      "festival": "திருவிழா",
      "birthday": "பிறந்தநாள்",
      "anniversary": "ஆண்டு விழா",
      "holiday": "விடுமுறை",
      "other": "மற்றவை",
      "no_media_found": "மீடியா எதுவும் இல்லை. உங்கள் வடிகட்டிகளை சரிசெய்ய முயற்சிக்கவும்.",
      "menu": "மெனு",
      "admin_panel": "நிர்வாக பேனல்",
      "wishes": "வாழ்த்துக்கள்",
      "language": "மொழி",
      "month_january": "ஜனவரி",
      "month_february": "பிப்ரவரி",
      "month_march": "மார்ச்",
      "month_april": "ஏப்ரல்",
      "month_may": "மே",
      "month_june": "ஜூன்",
      "month_july": "ஜூலை",
      "month_august": "ஆகஸ்ட்",
      "month_september": "செப்டம்பர்",
      "month_october": "அக்டோபர்",
      "month_november": "நவம்பர்",
      "month_december": "டிசம்பர்",
      "day_sun": "ஞாயிறு",
      "day_mon": "திங்கள்",
      "day_tue": "செவ்வாய்",
      "day_wed": "புதன்",
      "day_thu": "வியாழன்",
      "day_fri": "வெள்ளி",
      "day_sat": "சனி",
      "click_smiley_text": "கிளிக் செய்யவும்",
      "for_greetings_text": "தனிப்பயனாக்கப்பட்ட வாழ்த்துக்களுக்கு",
      "no_festival_month": "இந்த மாதம் திருவிழா இல்லை",
      "no_festival_scheduled": "இந்த மாதத்திற்கு திருவிழாக்கள் எதுவும் திட்டமிடப்படவில்லை.",
      "install_app": "iPhone இல் செயலியை நிறுவவும்",
      "ios_install_instruction_1": "இந்த செயலியை உங்கள் iPhone முகப்பு திரையில் சேர்க்க இந்த படிகளைப் பின்பற்றவும்:",
      "ios_install_step_1": "பகிர் பொத்தானைத் தட்டவும் ",
      "ios_install_step_1_suffix": " Safari உலாவியின் கீழே",
      "ios_install_step_2": "கீழே உருட்டி \"முகப்பு திரையில் சேர்\" என்பதைத் தட்டவும்",
      "ios_install_step_3": "உறுதிப்படுத்த மேல் வலது மூலையில் \"சேர்\" பொத்தானைத் தட்டவும்",
      "ios_install_step_4": "செயலி ஐகான் உங்கள் முகப்பு திரையில் தோன்றும், நீங்கள் வேறு எந்த செயலியைப் போலவும் திறக்கலாம்!"
    }
  },
  ml: {
    translation: {
      "app_name": "ഇന്ത്യൻ ഉത്സവ കലണ്ടർ",
      "select_language": "നിങ്ങളുടെ ഭാഷ തിരഞ്ഞെടുക്കുക",
      "welcome": "സ്വാഗതം",
      "festivals": "ഉത്സവങ്ങൾ",
      "calendar": "കലണ്ടർ",
      "login": "ലോഗിൻ",
      "logout": "ലോഗൗട്ട്",
      "email": "ഇമെയിൽ",
      "password": "പാസ്‌വേഡ്",
      "admin_dashboard": "അഡ്മിൻ ഡാഷ്‌ബോർഡ്",
      "super_admin": "സൂപ്പർ അഡ്മിൻ",
      "manage_festivals": "ഉത്സവങ്ങൾ നിയന്ത്രിക്കുക",
      "manage_languages": "ഭാഷകൾ നിയന്ത്രിക്കുക",
      "manage_users": "ഉപയോക്താക്കളെ നിയന്ത്രിക്കുക",
      "reports": "റിപ്പോർട്ടുകൾ",
      "add_festival": "ഉത്സവം ചേർക്കുക",
      "edit_festival": "ഉത്സവം എഡിറ്റ് ചെയ്യുക",
      "delete_festival": "ഉത്സവം ഇല്ലാതാക്കുക",
      "festival_name": "ഉത്സവത്തിന്റെ പേര്",
      "festival_date": "തീയതി",
      "festival_description": "വിവരണം",
      "images": "ചിത്രങ്ങൾ",
      "videos": "വീഡിയോകൾ",
      "save": "സംരക്ഷിക്കുക",
      "cancel": "റദ്ദാക്കുക",
      "delete": "ഇല്ലാതാക്കുക",
      "view_details": "വിശദാംശങ്ങൾ കാണുക",
      "close": "അടയ്ക്കുക",
      "loading": "ലോഡ് ചെയ്യുന്നു...",
      "no_festivals": "ഉത്സവങ്ങളൊന്നും കണ്ടെത്തിയില്ല",
      "theme": "തീം",
      "light": "പ്രകാശം",
      "dark": "ഇരുട്ട്",
      "light_mode": "ലൈറ്റ് മോഡ്",
      "dark_mode": "ഡാർക്ക് മോഡ്",
      "wishes_gallery": "ആശംസകൾ ഗാലറി",
      "wishes_gallery_subtitle": "ഒരു ടെംപ്ലേറ്റ് തിരഞ്ഞെടുത്ത് നിങ്ങളുടെ വ്യക്തിഗത സന്ദേശം ചേർക്കുക",
      "search_placeholder": "അവസരം അല്ലെങ്കിൽ ടാഗുകൾ ഉപയോഗിച്ച് തിരയുക...",
      "filters": "ഫിൽട്ടറുകൾ",
      "all": "എല്ലാം",
      "festival": "ഉത്സവം",
      "birthday": "ജന്മദിനം",
      "anniversary": "വാർഷികം",
      "holiday": "അവധി",
      "other": "മറ്റുള്ളവ",
      "no_media_found": "മീഡിയ കണ്ടെത്തിയില്ല. നിങ്ങളുടെ ഫിൽട്ടറുകൾ ക്രമീകരിക്കാൻ ശ്രമിക്കുക.",
      "menu": "മെനു",
      "admin_panel": "അഡ്മിൻ പാനൽ",
      "wishes": "ആശംസകൾ",
      "language": "ഭാഷ",
      "month_january": "ജനുവരി",
      "month_february": "ഫെബ്രുവരി",
      "month_march": "മാർച്ച്",
      "month_april": "ഏപ്രിൽ",
      "month_may": "മേയ്",
      "month_june": "ജൂൺ",
      "month_july": "ജൂലൈ",
      "month_august": "ഓഗസ്റ്റ്",
      "month_september": "സെപ്റ്റംബർ",
      "month_october": "ഒക്ടോബർ",
      "month_november": "നവംബർ",
      "month_december": "ഡിസംബർ",
      "day_sun": "ഞായർ",
      "day_mon": "തിങ്കൾ",
      "day_tue": "ചൊവ്വ",
      "day_wed": "ബുധൻ",
      "day_thu": "വ്യാഴം",
      "day_fri": "വെള്ളി",
      "day_sat": "ശനി",
      "click_smiley_text": "ക്ലിക്ക് ചെയ്യുക",
      "for_greetings_text": "വ്യക്തിഗത ആശംസകൾക്കായി",
      "no_festival_month": "ഈ മാസം ഉത്സവമില്ല",
      "no_festival_scheduled": "ഈ മാസത്തേക്ക് ഉത്സവങ്ങളൊന്നും ഷെഡ്യൂൾ ചെയ്തിട്ടില്ല.",
      "ml_month_chingam": "ചിങ്ങം",
      "ml_month_kanni": "കന്നി",
      "ml_month_thulam": "തുലാം",
      "ml_month_vrischikam": "വൃശ്ചികം",
      "ml_month_dhanu": "ധനു",
      "ml_month_makaram": "മകരം",
      "ml_month_kumbham": "കുംഭം",
      "ml_month_meenam": "മീനം",
      "ml_month_medam": "മേടം",
      "ml_month_edavam": "ഇടവം",
      "ml_month_mithunam": "മിഥുനം",
      "ml_month_karkidakam": "കർക്കടകം",
      "install_app": "iPhone-ൽ ആപ്പ് ഇൻസ്റ്റാൾ ചെയ്യുക",
      "ios_install_instruction_1": "ഈ ആപ്പ് നിങ്ങളുടെ iPhone ഹോം സ്ക്രീനിൽ ചേർക്കാൻ ഈ ഘട്ടങ്ങൾ പാലിക്കുക:",
      "ios_install_step_1": "ഷെയർ ബട്ടൺ ടാപ്പ് ചെയ്യുക ",
      "ios_install_step_1_suffix": " Safari ബ്രൗസറിന്റെ താഴെ",
      "ios_install_step_2": "താഴേക്ക് സ്ക്രോൾ ചെയ്ത് \"ഹോം സ്ക്രീനിലേക്ക് ചേർക്കുക\" എന്നതിൽ ടാപ്പ് ചെയ്യുക",
      "ios_install_step_3": "സ്ഥിരീകരിക്കാൻ മുകളിൽ വലതുവശത്തുള്ള \"ചേർക്കുക\" ബട്ടൺ ടാപ്പ് ചെയ്യുക",
      "ios_install_step_4": "ആപ്പ് ഐക്കൺ നിങ്ങളുടെ ഹോം സ്ക്രീനിൽ ദൃശ്യമാകും, നിങ്ങൾക്ക് മറ്റേതെങ്കിലും ആപ്പ് പോലെ അത് തുറക്കാം!"
    }
  },
  gu: {
    translation: {
      "app_name": "ભારતીય તહેવાર કેલેન્ડર",
      "select_language": "તમારી ભાષા પસંદ કરો",
      "welcome": "સ્વાગત છે",
      "festivals": "તહેવારો",
      "calendar": "કેલેન્ડર",
      "login": "લોગિન",
      "logout": "લૉગઆઉટ",
      "email": "ઇમેઇલ",
      "password": "પાસવર્ડ",
      "admin_dashboard": "એડમિન ડેશબોર્ડ",
      "super_admin": "સુપર એડમિન",
      "manage_festivals": "તહેવારો સંચાલિત કરો",
      "manage_languages": "ભાષાઓ સંચાલિત કરો",
      "manage_users": "વપરાશકર્તાઓને સંચાલિત કરો",
      "reports": "રિપોર્ટ્સ",
      "add_festival": "તહેવાર ઉમેરો",
      "edit_festival": "તહેવાર સંપાદિત કરો",
      "delete_festival": "તહેવાર કાઢી નાખો",
      "festival_name": "તહેવારનું નામ",
      "festival_date": "તારીખ",
      "festival_description": "વર્ણન",
      "images": "છબીઓ",
      "videos": "વિડિયો",
      "save": "સાચવો",
      "cancel": "રદ કરો",
      "delete": "કાઢી નાખો",
      "view_details": "વિગતો જુઓ",
      "close": "બંધ કરો",
      "loading": "લોડ થઈ રહ્યું છે...",
      "no_festivals": "કોઈ તહેવારો મળ્યા નથી",
      "theme": "થીમ",
      "light": "પ્રકાશ",
      "dark": "અંધારું",
      "light_mode": "લાઇટ મોડ",
      "dark_mode": "ડાર્ક મોડ",
      "wishes_gallery": "શુભેચ્છા ગેલેરી",
      "wishes_gallery_subtitle": "એક ટેમ્પલેટ પસંદ કરો અને તમારો વ્યક્તિગત સંદેશ ઉમેરો",
      "search_placeholder": "પ્રસંગ અથવા ટેગ્સ દ્વારા શોધો...",
      "filters": "ફિલ્ટર્સ",
      "all": "બધા",
      "festival": "તહેવાર",
      "birthday": "જન્મદિવસ",
      "anniversary": "વર્ષગાંઠ",
      "holiday": "રજા",
      "other": "અન્ય",
      "no_media_found": "કોઈ મીડિયા મળ્યું નથી. તમારા ફિલ્ટર્સ એડજસ્ટ કરવાનો પ્રયાસ કરો.",
      "menu": "મેનુ",
      "admin_panel": "એડમિન પેનલ",
      "wishes": "શુભેચ્છાઓ",
      "language": "ભાષા",
      "month_january": "જાન્યુઆરી",
      "month_february": "ફેબ્રુઆરી",
      "month_march": "માર્ચ",
      "month_april": "એપ્રિલ",
      "month_may": "મે",
      "month_june": "જૂન",
      "month_july": "જુલાઈ",
      "month_august": "ઓગસ્ટ",
      "month_september": "સપ્ટેમ્બર",
      "month_october": "ઓક્ટોબર",
      "month_november": "નવેમ્બર",
      "month_december": "ડિસેમ્બર",
      "day_sun": "રવિ",
      "day_mon": "સોમ",
      "day_tue": "મંગળ",
      "day_wed": "બુધ",
      "day_thu": "ગુરુ",
      "day_fri": "શુક્ર",
      "day_sat": "શનિ",
      "click_smiley_text": "ક્લિક કરો",
      "for_greetings_text": "વ્યક્તિગત શુભેચ્છાઓ માટે",
      "no_festival_month": "આ મહિને તહેવાર નથી",
      "no_festival_scheduled": "આ મહિના માટે કોઈ તહેવારો સુનિશ્ચિત નથી.",
      "install_app": "iPhone પર એપ્લિકેશન ઇન્સ્ટોલ કરો",
      "ios_install_instruction_1": "આ એપ્લિકેશનને તમારી iPhone હોમ સ્ક્રીન પર ઉમેરવા માટે આ પગલાંઓ અનુસરો:",
      "ios_install_step_1": "શેર બટન પર ટેપ કરો ",
      "ios_install_step_1_suffix": " Safari બ્રાઉઝરની નીચે",
      "ios_install_step_2": "નીચે સ્ક્રોલ કરો અને \"હોમ સ્ક્રીન પર ઉમેરો\" પર ટેપ કરો",
      "ios_install_step_3": "પુષ્ટિ કરવા માટે ઉપરના જમણા ખૂણે \"ઉમેરો\" બટન પર ટેપ કરો",
      "ios_install_step_4": "એપ આઇકન તમારી હોમ સ્ક્રીન પર દેખાશે અને તમે તેને અન્ય કોઈપણ એપની જેમ ખોલી શકો છો!"
    }
  },
  mr: {
    translation: {
      "app_name": "भारतीय सण कॅलेंडर",
      "select_language": "तुमची भाषा निवडा",
      "welcome": "स्वागत आहे",
      "festivals": "सण",
      "calendar": "कॅलेंडर",
      "login": "लॉगिन",
      "logout": "लॉगआउट",
      "email": "ईमेल",
      "password": "पासवर्ड",
      "admin_dashboard": "प्रशासक डॅशबोर्ड",
      "super_admin": "सुपर प्रशासक",
      "manage_festivals": "सण व्यवस्थापित करा",
      "manage_languages": "भाषा व्यवस्थापित करा",
      "manage_users": "वापरकर्ते व्यवस्थापित करा",
      "reports": "अहवाल",
      "add_festival": "सण जोडा",
      "edit_festival": "सण संपादित करा",
      "delete_festival": "सण हटवा",
      "festival_name": "सणाचे नाव",
      "festival_date": "तारीख",
      "festival_description": "वर्णन",
      "images": "प्रतिमा",
      "videos": "व्हिडिओ",
      "save": "जतन करा",
      "cancel": "रद्द करा",
      "delete": "हटवा",
      "view_details": "तपशील पहा",
      "close": "बंद करा",
      "loading": "लोड होत आहे...",
      "no_festivals": "कोणतेही सण सापडले नाहीत",
      "theme": "थीम",
      "light": "प्रकाश",
      "dark": "गडद",
      "light_mode": "लाइट मोड",
      "dark_mode": "डार्क मोड",
      "wishes_gallery": "शुभेच्छा गॅलरी",
      "wishes_gallery_subtitle": "टेम्पलेट निवडा आणि तुमचा वैयक्तिक संदेश जोडा",
      "search_placeholder": "प्रसंग किंवा टॅगद्वारे शोधा...",
      "filters": "फिल्टर",
      "all": "सर्व",
      "festival": "सण",
      "birthday": "वाढदिवस",
      "anniversary": "वर्धापनदिन",
      "holiday": "सुट्टी",
      "other": "इतर",
      "no_media_found": "मीडिया सापडला नाही. तुमचे फिल्टर समायोजित करण्याचा प्रयत्न करा.",
      "menu": "मेनू",
      "admin_panel": "प्रशासक पॅनेल",
      "wishes": "शुभेच्छा",
      "language": "भाषा",
      "month_january": "जानेवारी",
      "month_february": "फेब्रुवारी",
      "month_march": "मार्च",
      "month_april": "एप्रिल",
      "month_may": "मे",
      "month_june": "जून",
      "month_july": "जुलै",
      "month_august": "ऑगस्ट",
      "month_september": "सप्टेंबर",
      "month_october": "ऑक्टोबर",
      "month_november": "नोव्हेंबर",
      "month_december": "डिसेंबर",
      "day_sun": "रवि",
      "day_mon": "सोम",
      "day_tue": "मंगळ",
      "day_wed": "बुध",
      "day_thu": "गुरु",
      "day_fri": "शुक्र",
      "day_sat": "शनि",
      "click_smiley_text": "क्लिक करा",
      "for_greetings_text": "वैयक्तिक शुभेच्छांसाठी",
      "no_festival_month": "या महिन्यात सण नाही",
      "no_festival_scheduled": "या महिन्यासाठी कोणतेही सण नियोजित नाहीत.",
      "install_app": "iPhone वर अॅप इंस्टॉल करा",
      "ios_install_instruction_1": "हा अॅप तुमच्या iPhone होम स्क्रीनवर जोडण्यासाठी या चरणांचे अनुसरण करा:",
      "ios_install_step_1": "शेअर बटणावर टॅप करा ",
      "ios_install_step_1_suffix": " Safari ब्राउझरच्या तळाशी",
      "ios_install_step_2": "खाली स्क्रोल करा आणि \"होम स्क्रीनवर जोडा\" वर टॅप करा",
      "ios_install_step_3": "पुष्टी करण्यासाठी वरच्या उजव्या कोपर्यात \"जोडा\" बटणावर टॅप करा",
      "ios_install_step_4": "अॅप आयकॉन तुमच्या होम स्क्रीनवर दिसेल आणि तुम्ही ते इतर कोणत्याही अॅपप्रमाणे उघडू शकता!"
    }
  },
  or: {
    translation: {
      "app_name": "ଭାରତୀୟ ପର୍ବ କ୍ୟାଲେଣ୍ଡର",
      "select_language": "ଆପଣଙ୍କ ଭାଷା ଚୟନ କରନ୍ତୁ",
      "welcome": "ସ୍ୱାଗତ",
      "festivals": "ପର୍ବ",
      "calendar": "କ୍ୟାଲେଣ୍ଡର",
      "login": "ଲଗଇନ୍",
      "logout": "ଲଗଆଉଟ୍",
      "email": "ଇମେଲ୍",
      "password": "ପାସୱାର୍ଡ",
      "admin_dashboard": "ଆଡମିନ୍ ଡ୍ୟାସବୋର୍ଡ",
      "super_admin": "ସୁପର ଆଡମିନ୍",
      "manage_festivals": "ପର୍ବ ପରିଚାଳନା କରନ୍ତୁ",
      "manage_languages": "ଭାଷା ପରିଚାଳନା କରନ୍ତୁ",
      "manage_users": "ବ୍ୟବହାରକାରୀମାନଙ୍କୁ ପରିଚାଳନା କରନ୍ତୁ",
      "reports": "ରିପୋର୍ଟ",
      "add_festival": "ପର୍ବ ଯୋଗ କରନ୍ତୁ",
      "edit_festival": "ପର୍ବ ସମ୍ପାଦନ କରନ୍ତୁ",
      "delete_festival": "ପର୍ବ ବିଲୋପ କରନ୍ତୁ",
      "festival_name": "ପର୍ବର ନାମ",
      "festival_date": "ତାରିଖ",
      "festival_description": "ବିବରଣୀ",
      "images": "ଚିତ୍ର",
      "videos": "ଭିଡିଓ",
      "save": "ସଞ୍ଚୟ କରନ୍ତୁ",
      "cancel": "ବାତିଲ୍ କରନ୍ତୁ",
      "delete": "ବିଲୋପ କରନ୍ତୁ",
      "view_details": "ବିବରଣୀ ଦେଖନ୍ତୁ",
      "close": "ବନ୍ଦ କରନ୍ତୁ",
      "loading": "ଲୋଡ୍ ହେଉଛି...",
      "no_festivals": "କୌଣସି ପର୍ବ ମିଳିଲା ନାହିଁ",
      "theme": "ଥିମ୍",
      "light": "ଆଲୋକ",
      "dark": "ଗାଢ଼",
      "light_mode": "ଲାଇଟ୍ ମୋଡ୍",
      "dark_mode": "ଡାର୍କ ମୋଡ୍",
      "wishes_gallery": "ଶୁଭେଚ୍ଛା ଗ୍ୟାଲେରୀ",
      "wishes_gallery_subtitle": "ଏକ ଟେମ୍ପଲେଟ୍ ଚୟନ କରନ୍ତୁ ଏବଂ ଆପଣଙ୍କର ବ୍ୟକ୍ତିଗତ ସନ୍ଦେଶ ଯୋଗ କରନ୍ତୁ",
      "search_placeholder": "ଉତ୍ସବ କିମ୍ବା ଟ୍ୟାଗ୍ ଦ୍ୱାରା ଖୋଜନ୍ତୁ...",
      "filters": "ଫିଲ୍ଟର",
      "all": "ସମସ୍ତ",
      "festival": "ପର୍ବ",
      "birthday": "ଜନ୍ମଦିନ",
      "anniversary": "ବାର୍ଷିକୀ",
      "holiday": "ଛୁଟିଦିନ",
      "other": "ଅନ୍ୟାନ୍ୟ",
      "no_media_found": "କୌଣସି ମିଡିଆ ମିଳିଲା ନାହିଁ। ଆପଣଙ୍କର ଫିଲ୍ଟର ସଜାଡ଼ିବାକୁ ଚେଷ୍ଟା କରନ୍ତୁ।",
      "menu": "ମେନୁ",
      "admin_panel": "ଆଡମିନ୍ ପ୍ୟାନେଲ୍",
      "wishes": "ଶୁଭେଚ୍ଛା",
      "language": "ଭାଷା",
      "month_january": "ଜାନୁଆରୀ",
      "month_february": "ଫେବୃଆରୀ",
      "month_march": "ମାର୍ଚ୍ଚ",
      "month_april": "ଏପ୍ରିଲ୍",
      "month_may": "ମେ",
      "month_june": "ଜୁନ୍",
      "month_july": "ଜୁଲାଇ",
      "month_august": "ଅଗଷ୍ଟ",
      "month_september": "ସେପ୍ଟେମ୍ବର",
      "month_october": "ଅକ୍ଟୋବର",
      "month_november": "ନଭେମ୍ବର",
      "month_december": "ଡିସେମ୍ବର",
      "day_sun": "ରବି",
      "day_mon": "ସୋମ",
      "day_tue": "ମଙ୍ଗଳ",
      "day_wed": "ବୁଧ",
      "day_thu": "ଗୁରୁ",
      "day_fri": "ଶୁକ୍ର",
      "day_sat": "ଶନି",
      "click_smiley_text": "କ୍ଲିକ୍ କରନ୍ତୁ",
      "for_greetings_text": "ବ୍ୟକ୍ତିଗତ ଶୁଭେଚ୍ଛା ପାଇଁ",
      "no_festival_month": "ଏହି ମାସରେ କୌଣସି ପର୍ବ ନାହିଁ",
      "no_festival_scheduled": "ଏହି ମାସ ପାଇଁ କୌଣସି ପର୍ବ ନିର୍ଧାରିତ ହୋଇନାହିଁ।",
      "install_app": "iPhone ରେ ଆପ୍ ଇନଷ୍ଟଲ୍ କରନ୍ତୁ",
      "ios_install_instruction_1": "ଏହି ଆପ୍କୁ ଆପଣଙ୍କ iPhone ହୋମ୍ ସ୍କ୍ରିନରେ ଯୋଗ କରିବାକୁ ଏହି ପଦକ୍ଷେପଗୁଡ଼ିକ ଅନୁସରଣ କରନ୍ତୁ:",
      "ios_install_step_1": "ଶେୟାର୍ ବଟନ୍ ଉପରେ ଟାପ୍ କରନ୍ତୁ ",
      "ios_install_step_1_suffix": " Safari ବ୍ରାଉଜର୍ ର ତଳେ",
      "ios_install_step_2": "ତଳକୁ ସ୍କ୍ରୋଲ୍ କରନ୍ତୁ ଏବଂ \"ହୋମ୍ ସ୍କ୍ରିନରେ ଯୋଗ କରନ୍ତୁ\" ଉପରେ ଟାପ୍ କରନ୍ତୁ",
      "ios_install_step_3": "ନିଶ୍ଚିତ କରିବାକୁ ଉପରେ ଡାହାଣ କୋଣରେ \"ଯୋଗ କରନ୍ତୁ\" ବଟନ୍ ଉପରେ ଟାପ୍ କରନ୍ତୁ",
      "ios_install_step_4": "ଆପ୍ ଆଇକନ୍ ଆପଣଙ୍କ ହୋମ୍ ସ୍କ୍ରିନରେ ଦେଖାଯିବ ଏବଂ ଆପଣ ଏହାକୁ ଅନ୍ୟ ଯେକୌଣସି ଆପ୍ ପରି ଖୋଲିପାରିବେ!"
    }
  },
  te: {
    translation: {
      "app_name": "భారతీయ పండుగల క్యాలెండర్",
      "select_language": "మీ భాషను ఎంచుకోండి",
      "welcome": "స్వాగతం",
      "festivals": "పండుగలు",
      "calendar": "క్యాలెండర్",
      "login": "లాగిన్",
      "logout": "లాగ్అవుట్",
      "email": "ఇమెయిల్",
      "password": "పాస్‌వర్డ్",
      "admin_dashboard": "అడ్మిన్ డాష్‌బోర్డ్",
      "super_admin": "సూపర్ అడ్మిన్",
      "manage_festivals": "పండుగలను నిర్వహించండి",
      "manage_languages": "భాషలను నిర్వహించండి",
      "manage_users": "వినియోగదారులను నిర్వహించండి",
      "reports": "నివేదికలు",
      "add_festival": "పండుగను జోడించండి",
      "edit_festival": "పండుగను సవరించండి",
      "delete_festival": "పండుగను తొలగించండి",
      "festival_name": "పండుగ పేరు",
      "festival_date": "తేదీ",
      "festival_description": "వివరణ",
      "images": "చిత్రాలు",
      "videos": "వీడియోలు",
      "save": "సేవ్ చేయండి",
      "cancel": "రద్దు చేయండి",
      "delete": "తొలగించండి",
      "view_details": "వివరాలు చూడండి",
      "close": "మూసివేయండి",
      "loading": "లోడ్ అవుతోంది...",
      "no_festivals": "పండుగలు కనుగొనబడలేదు",
      "theme": "థీమ్",
      "light": "కాంతి",
      "dark": "ముదురు",
      "light_mode": "లైట్ మోడ్",
      "dark_mode": "డార్క్ మోడ్",
      "wishes_gallery": "శుభాకాంక్షల గ్యాలరీ",
      "wishes_gallery_subtitle": "టెంప్లేట్‌ను ఎంచుకుని మీ వ్యక్తిగత సందేశాన్ని జోడించండి",
      "search_placeholder": "సందర్భం లేదా ట్యాగ్‌ల ద్వారా శోధించండి...",
      "filters": "ఫిల్టర్లు",
      "all": "అన్నీ",
      "festival": "పండుగ",
      "birthday": "పుట్టినరోజు",
      "anniversary": "వార్షికోత్సవం",
      "holiday": "సెలవుదిన",
      "other": "ఇతరములు",
      "no_media_found": "మీడియా కనుగొనబడలేదు. మీ ఫిల్టర్‌లను సర్దుబాటు చేయడానికి ప్రయత్నించండి.",
      "menu": "మెనూ",
      "admin_panel": "అడ్మిన్ ప్యానెల్",
      "wishes": "శుభాకాంక్షలు",
      "language": "భాష",
      "month_january": "జనవరి",
      "month_february": "ఫిబ్రవరి",
      "month_march": "మార్చి",
      "month_april": "ఏప్రిల్",
      "month_may": "మే",
      "month_june": "జూన్",
      "month_july": "జూలై",
      "month_august": "ఆగస్టు",
      "month_september": "సెప్టెంబర్",
      "month_october": "అక్టోబర్",
      "month_november": "నవంబర్",
      "month_december": "డిసెంబర్",
      "day_sun": "ఆది",
      "day_mon": "సోమ",
      "day_tue": "మంగళ",
      "day_wed": "బుధ",
      "day_thu": "గురు",
      "day_fri": "శుక్ర",
      "day_sat": "శని",
      "click_smiley_text": "క్లిక్ చేయండి",
      "for_greetings_text": "వ్యక్తిగత శుభాకాంక్షల కోసం",
      "no_festival_month": "ఈ నెలలో పండుగ లేదు",
      "no_festival_scheduled": "ఈ నెలకు ఎటువంటి పండుగలు షెడ్యూల్ చేయబడలేదు.",
      "install_app": "iPhone లో యాప్ ఇన్‌స్టాల్ చేయండి",
      "ios_install_instruction_1": "ఈ యాప్‌ను మీ iPhone హోమ్ స్క్రీన్‌కు జోడించడానికి ఈ దశలను అనుసరించండి:",
      "ios_install_step_1": "షేర్ బటన్ ట్యాప్ చేయండి ",
      "ios_install_step_1_suffix": " Safari బ్రౌజర్ దిగువన",
      "ios_install_step_2": "క్రిందికి స్క్రోల్ చేసి \"హోమ్ స్క్రీన్‌కు జోడించు\" ని ట్యాప్ చేయండి",
      "ios_install_step_3": "నిర్ధారించడానికి ఎగువ కుడి మూలలో \"జోడించు\" బటన్ ట్యాప్ చేయండి",
      "ios_install_step_4": "యాప్ ఐకాన్ మీ హోమ్ స్క్రీన్‌లో కనిపిస్తుంది మరియు మీరు దానిని ఏదైనా ఇతర యాప్ లాగా తెరవవచ్చు!"
    }
  },
  kn: {
    translation: {
      "app_name": "ಭಾರತೀಯ ಹಬ್ಬಗಳ ಕ್ಯಾಲೆಂಡರ್",
      "select_language": "ನಿಮ್ಮ ಭಾಷೆಯನ್ನು ಆಯ್ಕೆಮಾಡಿ",
      "welcome": "ಸ್ವಾಗತ",
      "festivals": "ಹಬ್ಬಗಳು",
      "calendar": "ಕ್ಯಾಲೆಂಡರ್",
      "login": "ಲಾಗಿನ್",
      "logout": "ಲಾಗ್ಔಟ್",
      "email": "ಇಮೇಲ್",
      "password": "ಪಾಸ್‌ವರ್ಡ್",
      "admin_dashboard": "ಅಡ್ಮಿನ್ ಡ್ಯಾಶ್‌ಬೋರ್ಡ್",
      "super_admin": "ಸೂಪರ್ ಅಡ್ಮಿನ್",
      "manage_festivals": "ಹಬ್ಬಗಳನ್ನು ನಿರ್ವಹಿಸಿ",
      "manage_languages": "ಭಾಷೆಗಳನ್ನು ನಿರ್ವಹಿಸಿ",
      "manage_users": "ಬಳಕೆದಾರರನ್ನು ನಿರ್ವಹಿಸಿ",
      "reports": "ವರದಿಗಳು",
      "add_festival": "ಹಬ್ಬವನ್ನು ಸೇರಿಸಿ",
      "edit_festival": "ಹಬ್ಬವನ್ನು ಸಂಪಾದಿಸಿ",
      "delete_festival": "ಹಬ್ಬವನ್ನು ಅಳಿಸಿ",
      "festival_name": "ಹಬ್ಬದ ಹೆಸರು",
      "festival_date": "ದಿನಾಂಕ",
      "festival_description": "ವಿವರಣೆ",
      "images": "ಚಿತ್ರಗಳು",
      "videos": "ವೀಡಿಯೊಗಳು",
      "save": "ಉಳಿಸಿ",
      "cancel": "ರದ್ದುಮಾಡಿ",
      "delete": "ಅಳಿಸಿ",
      "view_details": "ವಿವರಗಳನ್ನು ವೀಕ್ಷಿಸಿ",
      "close": "ಮುಚ್ಚಿ",
      "loading": "ಲೋಡ್ ಆಗುತ್ತಿದೆ...",
      "no_festivals": "ಯಾವುದೇ ಹಬ್ಬಗಳು ಕಂಡುಬಂದಿಲ್ಲ",
      "theme": "ಥೀಮ್",
      "light": "ಬೆಳಕು",
      "dark": "ಕತ್ತಲೆ",
      "light_mode": "ಲೈಟ್ ಮೋಡ್",
      "dark_mode": "ಡಾರ್ಕ್ ಮೋಡ್",
      "wishes_gallery": "ಶುಭಾಶಯಗಳ ಗ್ಯಾಲರಿ",
      "wishes_gallery_subtitle": "ಟೆಂಪ್ಲೇಟ್ ಆಯ್ಕೆಮಾಡಿ ಮತ್ತು ನಿಮ್ಮ ವೈಯಕ್ತಿಕ ಸಂದೇಶವನ್ನು ಸೇರಿಸಿ",
      "search_placeholder": "ಸಂದರ್ಭ ಅಥವಾ ಟ್ಯಾಗ್‌ಗಳ ಮೂಲಕ ಹುಡುಕಿ...",
      "filters": "ಫಿಲ್ಟರ್‌ಗಳು",
      "all": "ಎಲ್ಲಾ",
      "festival": "ಹಬ್ಬ",
      "birthday": "ಹುಟ್ಟುಹಬ್ಬ",
      "anniversary": "ವಾರ್ಷಿಕೋತ್ಸವ",
      "holiday": "ರಜೆ",
      "other": "ಇತರೆ",
      "no_media_found": "ಯಾವುದೇ ಮಾಧ್ಯಮ ಕಂಡುಬಂದಿಲ್ಲ. ನಿಮ್ಮ ಫಿಲ್ಟರ್‌ಗಳನ್ನು ಸರಿಹೊಂದಿಸಲು ಪ್ರಯತ್ನಿಸಿ.",
      "menu": "ಮೆನು",
      "admin_panel": "ಅಡ್ಮಿನ್ ಪ್ಯಾನಲ್",
      "wishes": "ಶುಭಾಶಯಗಳು",
      "language": "ಭಾಷೆ",
      "month_january": "ಜನವರಿ",
      "month_february": "ಫೆಬ್ರವರಿ",
      "month_march": "ಮಾರ್ಚ್",
      "month_april": "ಏಪ್ರಿಲ್",
      "month_may": "ಮೇ",
      "month_june": "ಜೂನ್",
      "month_july": "ಜುಲೈ",
      "month_august": "ಆಗಸ್ಟ್",
      "month_september": "ಸೆಪ್ಟೆಂಬರ್",
      "month_october": "ಅಕ್ಟೋಬರ್",
      "month_november": "ನವೆಂಬರ್",
      "month_december": "ಡಿಸೆಂಬರ್",
      "day_sun": "ಭಾನು",
      "day_mon": "ಸೋಮ",
      "day_tue": "ಮಂಗಳ",
      "day_wed": "ಬುಧ",
      "day_thu": "ಗುರು",
      "day_fri": "ಶುಕ್ರ",
      "day_sat": "ಶನಿ",
      "click_smiley_text": "ಕ್ಲಿಕ್ ಮಾಡಿ",
      "for_greetings_text": "ವೈಯಕ್ತಿಕ ಶುಭಾಶಯಗಳಿಗಾಗಿ",
      "no_festival_month": "ಈ ತಿಂಗಳು ಹಬ್ಬವಿಲ್ಲ",
      "no_festival_scheduled": "ಈ ತಿಂಗಳಿಗೆ ಯಾವುದೇ ಹಬ್ಬಗಳನ್ನು ನಿಗದಿಪಡಿಸಲಾಗಿಲ್ಲ.",
      "install_app": "iPhone ನಲ್ಲಿ ಆ್ಯಪ್ ಇನ್‌ಸ್ಟಾಲ್ ಮಾಡಿ",
      "ios_install_instruction_1": "ಈ ಆ್ಯಪ್ ಅನ್ನು ನಿಮ್ಮ iPhone ಹೋಮ್ ಸ್ಕ್ರೀನ್‌ಗೆ ಸೇರಿಸಲು ಈ ಹಂತಗಳನ್ನು ಅನುಸರಿಸಿ:",
      "ios_install_step_1": "ಹಂಚಿಕೆ ಬಟನ್ ಟ್ಯಾಪ್ ಮಾಡಿ ",
      "ios_install_step_1_suffix": " Safari ಬ್ರೌಸರ್‌ನ ಕೆಳಭಾಗದಲ್ಲಿ",
      "ios_install_step_2": "ಕೆಳಗೆ ಸ್ಕ್ರಾಲ್ ಮಾಡಿ ಮತ್ತು \"ಹೋಮ್ ಸ್ಕ್ರೀನ್‌ಗೆ ಸೇರಿಸಿ\" ಅನ್ನು ಟ್ಯಾಪ್ ಮಾಡಿ",
      "ios_install_step_3": "ದೃಢೀಕರಿಸಲು ಮೇಲಿನ ಬಲ ಮೂಲೆಯಲ್ಲಿ \"ಸೇರಿಸಿ\" ಬಟನ್ ಟ್ಯಾಪ್ ಮಾಡಿ",
      "ios_install_step_4": "ಆ್ಯಪ್ ಐಕಾನ್ ನಿಮ್ಮ ಹೋಮ್ ಸ್ಕ್ರೀನ್‌ನಲ್ಲಿ ಕಾಣಿಸಿಕೊಳ್ಳುತ್ತದೆ ಮತ್ತು ನೀವು ಅದನ್ನು ಯಾವುದೇ ಇತರ ಆ್ಯಪ್‌ನಂತೆ ತೆರೆಯಬಹುದು!"
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
